import React from 'react';
import { Shape } from 'react-konva';

import { getElementNodeId } from '../../core/documentSchema';
import { drawShape } from './drawShape';

function ShapeElement({
  element,
  interactive,
  listening = true,
  onSelect,
  onContextMenu,
  onDragStart,
  onDragMove,
  onDragEnd,
  onTransformEnd,
}) {
  if (!element.visible) {
    return null;
  }

  const { shadow } = element;

  return (
    <Shape
      id={getElementNodeId(element.id)}
      name='ms-shape'
      x={element.x}
      y={element.y}
      width={element.width}
      height={element.height}
      offsetX={element.width / 2}
      offsetY={element.height / 2}
      scaleX={element.scaleX}
      scaleY={element.scaleY}
      rotation={element.rotation}
      opacity={element.opacity}
      globalCompositeOperation={element.blendMode}
      listening={listening}
      draggable={interactive}
      perfectDrawEnabled={false}
      sceneFunc={(context, shape) => {
        const ctx = context._context;
        if (element.blur > 0 && 'filter' in ctx) {
          const matrix = ctx.getTransform();
          ctx.filter = `blur(${element.blur * (Math.hypot(matrix.a, matrix.b) || 1)}px)`;
        }
        drawShape(ctx, element, shape.width(), shape.height());
        ctx.filter = 'none';
      }}
      shadowEnabled={shadow.enabled}
      shadowColor={shadow.color}
      shadowBlur={shadow.blur}
      shadowOffsetX={shadow.offsetX}
      shadowOffsetY={shadow.offsetY}
      shadowOpacity={shadow.opacity}
      hitFunc={(context, shape) => {
        const height = shape.height();
        const pad = Math.max(0, (shape.width() * 0.06 - height) / 2);
        context.beginPath();
        context.rect(0, -pad, shape.width(), height + pad * 2);
        context.closePath();
        context.fillShape(shape);
      }}
      onClick={(event) => onSelect?.(element.id, event)}
      onTap={(event) => onSelect?.(element.id, event)}
      onContextMenu={(event) => onContextMenu?.(element, event)}
      onDragStart={() => onDragStart?.(element.id)}
      onDragMove={interactive ? (event) => onDragMove?.(element, event) : undefined}
      onDragEnd={(event) => onDragEnd?.(element.id, event)}
      onTransformEnd={(event) => onTransformEnd?.(element.id, event)}
    />
  );
}

export default ShapeElement;
